import {
    VendorNavDashboardSvg,
    VendorNavMembersSvg,
    VendorNavTicketsSvg,
    VendorNavDocumentsSvg,
} from "../../../CommonSvg";
import { VendorViewMemberListAccess } from "../../../../constant/commonConstants";

export const VENDOR_NAV_ITEMS = [
    { to: "/vendor/dashboard", label: "Dashboard", Icon: VendorNavDashboardSvg },
    { to: "/vendor/members", label: "Member Stores", Icon: VendorNavMembersSvg, roleId: VendorViewMemberListAccess },
    { to: "/vendor/support-tickets", label: "Support Tickets", Icon: VendorNavTicketsSvg },
    { to: "/vendor/documents", label: "Document Management", Icon: VendorNavDocumentsSvg },
];
